var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedeemLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.999V14.999C4 18.2989 4 19.9488 5.02513 20.9739C6.05025 21.999 7.70017 21.999 11 21.999H13C16.2998 21.999 17.9497 21.999 18.9749 20.9739C20 19.9488 20 18.2989 20 14.999V10.999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.99902C3 8.25133 3 7.87748 3.20096 7.59902C3.33261 7.4166 3.52197 7.26511 3.75 7.15979C4.09808 6.99902 4.56538 6.99902 5.5 6.99902H18.5C19.4346 6.99902 19.9019 6.99902 20.25 7.15979C20.478 7.26511 20.6674 7.4166 20.799 7.59902C21 7.87748 21 8.25133 21 8.99902C21 9.74672 21 10.1206 20.799 10.399C20.6674 10.5814 20.478 10.7329 20.25 10.8383C19.9019 10.999 19.4346 10.999 18.5 10.999H5.5C4.56538 10.999 4.09808 10.999 3.75 10.8383C3.52197 10.7329 3.33261 10.5814 3.20096 10.399C3 10.1206 3 9.74672 3 8.99902Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.78474C6 2.79851 6.79949 1.99902 7.78571 1.99902H8.14286C10.2731 1.99902 12 3.72593 12 5.85617V6.99902H9.21429C7.43908 6.99902 6 5.55994 6 3.78474Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.78474C18 2.79851 17.2005 1.99902 16.2143 1.99902H15.8571C13.7269 1.99902 12 3.72593 12 5.85617V6.99902H14.7857C16.5609 6.99902 18 5.55994 18 3.78474Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.999L12 21.999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemLight);
export default __webpack_public_path__ + "static/media/redeem-light.89353cd82d2c38dd41961840b7368fda.svg";
export { ForwardRef as ReactComponent };